module.exports = __webpack_public_path__ + "static/media/date-icon.3ffc25b8.svg";